import React, { useState } from 'react';
import '../Common/styles/Charts.css';
import Perfil from './Perfil/Perfil';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import Services from './Services/Services';
import Stratification from './Stratification/Stratification';
import Production from './Production/Production';
import { HomeNav } from '../Common/Home/HomeNav';

const menus = [
    {
        title: 'Atendimentos',
        index: 1
    },
    {
        title: 'Perfil',
        index: 2
    },
    {
        title: 'Estratificação',
        index: 3,
    },
    {
        title: 'Produção',
        index: 4
    }
];

function DashBoardSiaSus() {
    const queryClient = new QueryClient();
    const [activeIndex, setActiveIndex] = useState(1);

    const renderPage = (activeIndex) => {
        switch (activeIndex) {
            case 1:
                return <Services setActiveIndex={setActiveIndex} />;
            case 2:
                return <Perfil setActiveIndex={setActiveIndex} />;
            case 3:
                return <Stratification setActiveIndex={setActiveIndex} />;
            case 4:
                return <Production setActiveIndex={setActiveIndex} />;
            default:
                return <Services setActiveIndex={setActiveIndex} />;
        }
    };

    return (
        <QueryClientProvider client={queryClient}>
            <ReactQueryDevtools initialIsOpen={false} />
            <HomeNav menus={menus} setActiveIndex={setActiveIndex} activeIndex={activeIndex} />
            {renderPage(activeIndex)}
        </QueryClientProvider>
    );
}

export default DashBoardSiaSus;
